import React from 'react';
import Grid from '@material-ui/core/Grid';
import Lock from '@material-ui/icons/Lock';
import Alert from '@material-ui/icons/Warning';

export const LoginError = props => {
  const { isUserLocked, error } = props;
  if (!error) return null;
  return (
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <div className="errorMessage">
        <span className="icon">{isUserLocked ? <Lock /> : <Alert />}</span>
        <span className="errorText">
          {error && error.message}
          {/*numberAttempts && !isUserLocked
                ? intl.getHTML('login.errorAttemptMessage', { numberAttempts, maxAttempts })
              : (error && error.message) || ''*/}
        </span>
      </div>
    </Grid>
  );
};

export default LoginError;



// WEBPACK FOOTER //
// ./src/ui/features/Login/presentational/forms/LoginErrorPres.js